import React from "react"

const CatalogSearch = ({ searching, onSearchOpen, onProductTextSearch }) => {
  const handleProductTextSearch = e => {
    e.preventDefault()
    onProductTextSearch(e.target.freeSearch)
  }

  return searching ? (
    <form
      className="flex gl-input__container"
      onSubmit={handleProductTextSearch}
    >
      <input
        className="gl-input--search gl-input__container mr-3"
        type="text"
        name="freeSearch"
        placeholder="Pesquisa livre..."
      />
      <button className="gl-outline-reset p-1" type="submit">
        <i className="gl-navbar__icon-find text-xl" />
      </button>
    </form>
  ) : (
    <button className="gl-outline-reset p-1" onClick={onSearchOpen}>
      <i className="fas fa-search text-xl dead-grey" />
    </button>
  )
}

export default CatalogSearch
